import React from "react";
import { Link } from "react-router-dom";
import styles from "../HeaderFooter.module.css";

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Link to="/shishka/main" className={styles.navItem}>
        Главная
      </Link>
      <Link
        to="/shishka/setup"
        className={`${styles.navItem} ${styles.active}`}
      >
        Настройки
      </Link>
      <Link to="/logout" className={styles.navItem}>
        Выход
      </Link>
    </footer>
  );
};

export default Footer;
